import script from "./survey-form.vue?vue&type=script&setup=true&lang=js"
export * from "./survey-form.vue?vue&type=script&setup=true&lang=js"

import "./survey-form.vue?vue&type=style&index=0&id=5a696a1c&lang=css"

const __exports__ = script;

export default __exports__